import { BOARDS_ENUMS, BOARDS_ID, BOARDS_ID_TO_URLS_MAP } from '@constants';

export const BOARD_ID_VALUE_TO_KEY = Object.entries(BOARDS_ID).reduce(
  (acc, [key, val]) => {
    acc[val] = key;
    return acc;
  },
  {}
);

export const BOARD_META_BY_ID = Object.values(BOARDS_ENUMS).reduce(
  (acc, board) => {
    if (!board?.board) return acc;

    acc[board.board] = {
      name: board.text,
      url: BOARDS_ID_TO_URLS_MAP[BOARD_ID_VALUE_TO_KEY[board.board]] || null,
    };

    return acc;
  },
  {}
);
